module.exports = __webpack_public_path__ + "static/media/Kaya Baca.41233e7b.png";